<div class="mat-elevation-z4">
  <ng-content></ng-content>
</div>
